import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  icon: {
    display: 'inline-block',
    marginRight: '.3rem',
    fontSize: '.7rem',
  },

  productClass: {
    justifyContent: 'space-between',
  },
}))

export default useStyles
